import type { Mutation } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'
import {
  FolderList,
  OtherProductDocumentsDetails,
  PostAddDocuments,
  ProductSaveFolderList,
} from '@/api/model/productModel'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  //商品格納先フォルダ一覧
  [actionTypes.SET_MODAL_DETAIL_FOLDER_ACTIVED]: (
    state: State,
    status: boolean
  ): void => {
    state.modalDetailFolderActived = status
  },

  //保存の確認ダイアログ
  [actionTypes.SET_MODAL_DETAIL_FOLDER_SUBMIT_ACTIVED]: (
    state: State,
    status: boolean
  ): void => {
    state.modalDetailFolderSubmitActived = status
  },

  //削除の確認ダイアログ
  [actionTypes.SET_MODAL_DETAIL_FOLDER_DELETE_ACTIVED]: (
    state: State,
    status: boolean
  ): void => {
    state.modalDetailFolderDeleteActived = status
  },

  //キャンセルの確認ダイアログ
  [actionTypes.SET_MODAL_DETAIL_FOLDER_CANCEL_ACTIVED]: (
    state: State,
    status: boolean
  ): void => {
    state.modalDetailFolderCancelActived = status
  },

  //格納するフォルダの指定
  [actionTypes.SET_MODAL_DETAIL_TREE_ACTIVED]: (state: State, status: boolean): void => {
    state.modalDetailTreeActived = status
  },

  //他の商品からドキュメント追加
  [actionTypes.SET_MODAL_DETAIL_OTHER_PRODUCT_DOCUMENT_ADD_ACTIVED]: (
    state: State,
    status: boolean
  ): void => {
    state.modalDetailOtherProductDocumentAddActived = status
  },

  //他の商品からドキュメント追加　追加確認ダイアログ
  [actionTypes.SET_MODAL_DETAIL_OTHER_PRODUCT_DOCUMENT_SUBMIT_ACTIVED]: (
    state: State,
    status: boolean
  ): void => {
    state.modalDetailOtherProductDocumentSubmitActived = status
  },

  //商品格納先フォルダ一覧 商品に紐付けるフォルダ
  [actionTypes.SET_PRODUCT_SAVE_FOLDER_LIST]: (
    state: State,
    list: ProductSaveFolderList
  ): void => {
    state.productSaveFolderList = list
  },

  //データ変化あるか比べ用
  [actionTypes.SET_ORIGIN_FOLDER_LIST]: (state: State, list: FolderList[]): void => {
    state.originFolderList = list
  },

  //表示用
  [actionTypes.SET_DISPLAY_FOLDER_LIST]: (state: State, list: FolderList[]): void => {
    state.displayFolderList = list
  },

  //表示データと比較用
  [actionTypes.SET_DISPLAY_FOLDER_LIST_BACKUP]: (
    state: State,
    list: FolderList[]
  ): void => {
    state.displayFolderListBackup = list
  },

  //変化したデータ
  [actionTypes.SET_CHANGED_FOLDER_LIST]: (state: State, list: FolderList[]): void => {
    state.changedFolderList = list
  },

  //商品格納先フォルダ一覧　apiを呼び出してデータ更新必要かのフラグ
  [actionTypes.SET_CALL_API]: (state: State, status: boolean): void => {
    state.callApi = status
  },

  //商品格納先フォルダ一覧　エラーメッセージ
  [actionTypes.SET_ERROR_MESSAGES_FOLDER_LIST]: (state: State, list: string[]): void => {
    state.errorMessagesFolderList = list
  },

  //格納するフォルダの指定　エラーメッセージ
  [actionTypes.SET_ERROR_MESSAGES_FOLDER_ADD]: (state: State, list: string[]): void => {
    state.errorMessagesFolderAdd = list
  },

  //削除するデータのフォルダID
  [actionTypes.SET_DELETE_FOLDER_ID]: (state: State, id: number): void => {
    state.deleteFolderId = id
  },

  //他の商品からドキュメント追加 追加するドキュメントデータ
  [actionTypes.SET_POST_ADD_DOCUMENTS]: (state: State, data: PostAddDocuments): void => {
    state.postAddDocuments = data
  },

  //他の商品からドキュメント追加 apiを呼び出してデータ更新必要かのフラグ
  [actionTypes.SET_CALL_API_DOCUMENTS]: (state: State, status: boolean): void => {
    state.callApiDocuments = status
  },

  //他の商品からドキュメント追加 ドキュメントデータ
  [actionTypes.SET_OTHER_PRODUCT_DOCUMENTS]: (
    state: State,
    data: OtherProductDocumentsDetails[]
  ): void => {
    state.otherProductDocuments = data
  },

  [actionTypes.SET_CSV_UPLOAD_PAGE]: (state: State, data: boolean): void => {
    state.csvUploadPage = data
    if (!state.csvUploadPage) {
      state.csvUploadPageStatus = 0
    }
  },

  [actionTypes.SET_CSV_UPLOAD_PAGE_STATUS]: (state: State, data: number): void => {
    state.csvUploadPageStatus = data
  },

  [actionTypes.SET_CSV_UPLOAD_PAGE_NUMBER]: (state: State, data: number): void => {
    state.csvUploadPageNumber = data
  },
  [actionTypes.SET_CSV_UPLOAD_GOODS_NAME]: (state: State, data: string): void => {
    state.csvUploadGoodsName = data
  },

  [actionTypes.SET_CSV_UPLOAD_GOODS_LIST]: (state: State, data: any): void => {
    state.csvUploadGoodsList = data
  },
  [actionTypes.SET_CSV_UPLOAD_FILE_NAME]: (state: State, data: string): void => {
    state.csvUploadFileName = data
  },

  [actionTypes.SET_CSV_UPLOAD_FILE_LIST]: (state: State, data: any): void => {
    state.csvUploadFileList = data
  },
  [actionTypes.SET_SELECTED_FILE]: (state: State, data: any): void => {
    state.selectedFile = data
  },
  [actionTypes.SET_MODAL_DELETE_PRODUCT_ACTIVED]: (state: State, boolean: boolean) => {
    state.modalDeleteProductActived = boolean
  },
}

export default mutations
